"use client"
import { Box, Typography } from "@mui/material"



export const LoadingPage = () => {
    return (
        <div className="h-screen w-screen flex justify-center items-center dark:bg-blue-cole-dark">
            <div className="absolute animate-spin   h-32 w-32 rounded-full border-t-4 border-b-4 border-blue-cole"></div>
            <img src="/img/logo.webp" className="rounded-full h-28 w-20" />
        </div>
    )
}
